exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".material-icons.close[data-v-a200150a] {\n  font-size: 21px;\n  position: absolute;\n  right: 0;\n  top: -5px;\n  color: #000;\n  border-radius: 50%;\n  background-color: #fff;\n}\n", ""]);

// exports
